export var LEVELS_MAP_CONST_TO_STRING = {
  grade_1: 'Grade 1',
  grade_2: 'Grade 2',
  grade_3: 'Grade 3',
  grade_4: 'Grade 4',
  grade_5: 'Grade 5',
  grade_6: 'Grade 6',
  grade_7: 'Grade 7',
  grade_8: 'Grade 8',
  grade_9: 'Grade 9',
  grade_10: 'Grade 10',
  grade_11: 'Grade 11',
  grade_12: 'Grade 12',
  highschool: 'Grade 12',
  english: 'English as Second Language (ESL)',
  certificate: '1-Year Post-Secondary Certificate',
  diploma: '2-Year Undergraduate Diploma',
  advanced_diploma: '3-Year Undergraduate Advanced Diploma',
  '3_year_bachelors': "3-Year Bachelor's Degree",
  bachelors: "4-Year Bachelor's Degree",
  post_graduate: "Postgraduate Certificate / Master's Degree",
  masters: "Master's Degree",
  doctoral: 'Doctoral Degree'
};
export var LEVELS_MAP_NUMBER_TO_STRING = {
  1: 'Grade 1',
  2: 'Grade 2',
  3: 'Grade 3',
  4: 'Grade 4',
  5: 'Grade 5',
  6: 'Grade 6',
  7: 'Grade 7',
  8: 'Grade 8',
  9: 'Grade 9',
  10: 'Grade 10',
  11: 'Grade 11',
  12: 'Grade 12',
  13: '1-Year Post-Secondary Certificate',
  14: '2-Year Undergraduate Diploma',
  15: '3-Year Undergraduate Advanced Diploma',
  16: "3-Year Bachelor's Degree",
  17: "4-Year Bachelor's Degree",
  18: "Postgraduate Certificate / Master's Degree",
  19: "Master's Degree",
  20: 'Doctoral Degree'
};
export var LEVELS_MAP_NUMBER_TO_CONST = {
  1: 'grade_1',
  2: 'grade_2',
  3: 'grade_3',
  4: 'grade_4',
  5: 'grade_5',
  6: 'grade_6',
  7: 'grade_7',
  8: 'grade_8',
  9: 'grade_9',
  10: 'grade_10',
  11: 'grade_11',
  12: 'highschool',
  13: 'certificate',
  14: 'diploma',
  15: 'advanced_diploma',
  16: '3_year_bachelors',
  17: 'bachelors',
  18: 'post_graduate',
  19: 'masters',
  20: 'doctoral'
};